'use client';
import React, { Component } from 'react';
import '../reusable-components/style.sass';

import GgeNumbers from '../reusable-components/layouts-components__gge/gge-numbers';
import Task from '../reusable-components/layouts-components__gge/tasks';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Complex from '../reusable-components/layouts-components__gge/complex';
import Process from '../reusable-components/layouts-components__gge/process';
import Results from '../reusable-components/layouts-components__gge/results';
import Digit from '../reusable-components/layouts-components__gge/digit';
import Team from '../reusable-components/layouts-components__gge/team';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';

import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const ggeMainTitle = {
    titleMainText: `Улучшение сайта Главгосэкспертизы России`,
    titleAnimation: '/images/pic/preview/gge.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#9d2235',
            nameText: 'ФАУ &laquo;Главгосэкспертиза России&raquo;',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#9d2235',
            nameText: 'Госсектор',
        },
        {
            modeText: 'Услуги',
            colorMode: '#9d2235',
            nameText: 'Модернизация сайта, техподдержка',
        },
        {
            modeText: 'Инструменты',
            colorMode: '#9d2235',
            nameText: 'PHP, Bitrix, React, Sentry, Prometheus, Grafana',
        },
    ],
};

const nextProjectGge = {
    nextProjectTitle:
        'Модернизация и&nbsp;многочисленные интеграции сайта школы &laquo;Летово&raquo;',
    nextProjectImg: '/images/pic/preview/letovo.png',
    nextProjectLink: '/cases/development/letovo',
    nextProjectLinkTitle: 'Школа «Летово»',
    nextProjectText:
        'Это школа международного уровня для одаренных детей, где преподают учителя из&nbsp;разных стран.',
};

class Gge extends Component {
    render() {
        return (
            <section className="gge">
                <MainTitle MainTitle={ggeMainTitle} />

                <GgeNumbers />

                <Task />

                <Complex />

                <Process />

                <Results />

                <Digit />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectGge} />
            </section>
        );
    }
}

export default Gge;
